<template>
    <div class="text-center d-flex justify-content-center pagination-button text-align-center overflow-x-auto">
        <!-- Previous button -->
        <a v-if="currentPage > 1" class="btn-gold d-inline-block d-flex align-items-center justify-content-center"
            style="width: 80px !important;" @click="prevPage">
            PREVIOUS
        </a>

        <!-- First page -->
        <a v-if="shouldShowFirst"
            :class="['btn-gold', 'd-inline-block', 'd-flex', 'align-items-center', 'justify-content-center', { active: currentPage === 1 }]"
            @click="setActivePage(1)">
            1
        </a>

        <!-- Left ellipsis -->
        <span v-if="shouldShowLeftEllipsis" class="px-2">...</span>

        <!-- Visible page range -->
        <a v-for="page in visiblePages" :key="page"
            :class="['btn-gold', 'd-inline-block', 'd-flex', 'align-items-center', 'justify-content-center', { active: currentPage === page }]"
            @click="setActivePage(page)">
            {{ page }}
        </a>

        <!-- Right ellipsis -->
        <span v-if="shouldShowRightEllipsis" class="px-2">...</span>

        <!-- Last page -->
        <a v-if="shouldShowLast" class="btn-gold d-inline-block d-flex align-items-center justify-content-center"
            @click="setActivePage(totalPages)">
            {{ totalPages }}
        </a>

        <!-- Next button -->
        <a v-if="currentPage < totalPages"
            class="btn-gold d-inline-block d-flex align-items-center justify-content-center"
            style="width: 80px !important;" @click="nextPage">
            NEXT PAGE
        </a>
    </div>
</template>


<script>
export default {
    name: 'PaginationButton',
    props: {
        totalPages: {
            type: Number,
            required: true
        },
        modelValue: {
            type: Number,
            required: true
        }
    },
    computed: {
        currentPage: {
            get() {
                return this.modelValue;
            },
            set(val) {
                window.scrollTo({ top: 0, behavior: 'smooth' });
                this.$emit('update:modelValue', val);
            }
        },
        visiblePages() {
            const maxVisible = 5;  // Adjust the number of visible pages here
            const pages = [];
            const total = this.totalPages;
            const current = this.currentPage;

            let start = Math.max(2, current - Math.floor(maxVisible / 2));
            let end = start + maxVisible - 1;

            if (end >= total) {
                end = total;
                start = Math.max(2, end - maxVisible + 1);
            }

            for (let i = start; i <= end; i++) {
                pages.push(i);
            }

            return pages;
        },
        shouldShowFirst() {
            return this.totalPages >= 1
        },
        shouldShowLast() {
            return this.totalPages > 1 && this.currentPage < this.totalPages - 2;
        },
        shouldShowLeftEllipsis() {
            return this.visiblePages.length > 0 && this.visiblePages[0] > 2;
        },
        shouldShowRightEllipsis() {
            return this.visiblePages.length > 0 && this.visiblePages[this.visiblePages.length - 1] < this.totalPages - 1;
        }
    },
    methods: {
        setActivePage(page) {
            this.currentPage = page;
        },
        nextPage() {
            if (this.currentPage < this.totalPages) {
                this.currentPage++;
            }
        },
        prevPage() {
            if (this.currentPage > 1) {
                this.currentPage--;
            }
        }
    }
};
</script>


<style scoped>
.pagination-button a {
    width: 30px;
    height: 30px;
    margin: 0 3px;
    padding: 0;
    font-size: 12px;
    font-weight: bold;
    cursor: pointer;
}

.pagination-button a.active {
    color: white;
    background-color: #233C8A !important;
}
</style>
